import { render, staticRenderFns } from "./textSetting.vue?vue&type=template&id=45ab267d&scoped=true"
import script from "./textSetting.vue?vue&type=script&lang=ts"
export * from "./textSetting.vue?vue&type=script&lang=ts"
import style0 from "./textSetting.vue?vue&type=style&index=0&id=45ab267d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_hlqzqdj4q3cge46xolaszrvwji/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ab267d",
  null
  
)

export default component.exports